import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import PasswordInput from '@/components/ui/password-input';
import Logo from '@/components/Logo';
import { toast } from 'sonner';
import api from '@/utils/api';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post('/auth/login', {
        username,
        password
      });

      toast.success('Login erfolgreich!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Ungültige Zugangsdaten');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <Logo size="medium" />
          </div>
          <CardTitle className="text-2xl font-bold text-[#4A331D]">Admin Login</CardTitle>
          <CardDescription>Melden Sie sich an, um das Dashboard zu verwalten</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="username">Benutzername</Label>
              <Input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="mt-2"
              />
            </div>
            <div>
              <Label htmlFor="password">Passwort</Label>
              <PasswordInput
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2"
                testId="login-password"
                autoComplete="current-password"
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-[#4A331D] hover:bg-[#593B23]"
              disabled={loading}
            >
              {loading ? 'Wird angemeldet...' : 'Anmelden'}
            </Button>
          </form>
          <div className="mt-4 text-sm text-gray-600 text-center">
            <p>Zugangsdaten vom Administrator</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;